// Подписи для журнала действий. Шлюз пишет раздел и действие из шаблона
// маршрута («integrations», «costs», «platform-roles», «create») — оператору
// это ничего не говорит. Неизвестное значение показывается как есть: новый
// маршрут не должен пропадать из журнала только потому, что его забыли
// подписать.

const ENTITY: Record<string, string> = {
	accounting: "Бухгалтерия",
	analytics: "Аналитика",
	applications: "Заявки продавцов",
	audit: "Журнал",
	buyers: "Покупатели",
	carts: "Корзины",
	catalog: "Каталог",
	categories: "Категории",
	commissions: "Комиссии",
	dashboard: "Дашборд",
	delivery: "Доставка",
	discovery: "Рекомендации",
	documents: "Документы",
	email: "Почта",
	exports: "Выгрузки",
	feed: "Лента",
	finances: "Финансы",
	geo: "География",
	ideas: "Идеи",
	"inspiration-feed": "Лента вдохновения",
	"inspiration-ideas": "Идеи ленты",
	integrations: "Интеграции",
	likes: "Избранное",
	managers: "Менеджеры",
	"notification-campaigns": "Рассылки",
	"notification-recipients": "Получатели рассылок",
	orders: "Заказы",
	payouts: "Выплаты",
	"platform-permissions": "Права",
	"platform-roles": "Роли площадки",
	"price-requests": "Заявки на цену",
	products: "Товары",
	promos: "Промокоды",
	questions: "Вопросы о товарах",
	reports: "Отчёты",
	returns: "Возвраты",
	review: "Отзыв",
	"review-complaints": "Жалобы на отзывы",
	sellers: "Продавцы",
	settings: "Настройки",
	shops: "Магазины",
	sms: "SMS",
	support: "Поддержка",
	users: "Пользователи",
}

const ACTION: Record<string, string> = {
	// Модерация отзывов (fd-admin-05): решение по жалобе продавца.
	hide: "отзыв скрыт",
	keep: "отзыв оставлен",
	restore: "отзыв возвращён",
	create: "создание",
	update: "изменение",
	delete: "удаление",
	call: "вызов",
	approve: "одобрение",
	reject: "отклонение",
	block: "блокировка",
	unblock: "разблокировка",
	assign: "назначение",
	move: "перевод по этапу",
	contacted: "отметка «связались»",
	"create-account": "создание аккаунта",
	"promote-wave": "волна обзвона",
	rework: "на доработку",
	check: "проверка соединения",
	costs: "расходы",
	metrika: "счётчик Метрики",
	moderation: "правила модерации",
	"reports-model": "модель ИИ отчётов",
	delivery: "доставка",
	carriers: "перевозчик",
	"carriers.check": "проверка перевозчика",
	"carriers.zones": "зоны курьера",
	generate: "формирование отчёта",
	password: "смена пароля",
	otp: "просмотр кода входа",
	status: "смена статуса",
	"confirm-invoice-payment": "подтверждение оплаты по счёту",
	send: "отправка",
	cancel: "отмена",
	preview: "предпросмотр",
	test: "проверка",
	"log.retry": "повтор письма",
	resume: "возобновление отправки",
	"refresh-statuses": "обновление статусов",
	decision: "решение",
	manager: "менеджер магазина",
	"team-lead": "руководитель группы",
	staff: "сотрудники",
	"staff.members": "сотрудник магазина",
	moderate: "модерация",
	curate: "подборка",
	reorder: "порядок",
	photo: "фото",
	"tickets.reply": "ответ в обращении",
	"tickets.status": "статус обращения",
	faq: "справка",
	received: "получен возврат",
	refunded: "деньги возвращены",
	resolve: "решение по возврату",
	"dispute.resolve": "решение по спору",
	"documents.file": "просмотр документа",
	documents: "документы",
	verification: "проверка продавца",
	"obligations.advance": "обязательство",
	"obligations.documents": "документы по обязательству",
	"org-expenses": "расходы площадки",
	settings: "настройки",
	rates: "ставка",
	"rates.bulk": "ставки массово",
	base: "базовая ставка",
	review: "проверка",
	"registry.export": "выгрузка реестра",
	"ad-points.adjust": "корректировка рекламных баллов",
}

export const auditEntityLabel = (kind: string): string => ENTITY[kind] ?? kind
export const auditActionLabel = (action: string): string => ACTION[action] ?? action

/** Ссылка на объект записи, если у раздела есть карточка. */
export const auditEntityLink = (kind: string, id: string): string | null => {
	if (!id) return null
	switch (kind) {
		case "products":
			return `/products/${encodeURIComponent(id)}`
		case "users":
			return `/users/${encodeURIComponent(id)}`
		case "notification-campaigns":
			return `/notification-campaigns/${encodeURIComponent(id)}`
		case "sellers":
			return `/shops/seller/${encodeURIComponent(id)}`
		case "integrations":
			return "/integrations"
		case "platform-roles":
			return "/platform-roles"
		default:
			return null
	}
}
